module.exports = __webpack_public_path__ + "img/prime-video.55ffface.png";